module.exports = __webpack_public_path__ + "static/about-6e158586c11f8534059c1f56d97cc7ec.png";